module.exports = __webpack_public_path__ + "img/premiumhouse_logo.c622c8ab.png";